export const ErrorCode = {
  FeedCreateFail: "feedCreateFail",
  FeedUpdateFail: "feedUpdateFail",
  NeedsSubscription: "needsSubscription",
  ErrorCreatingTrial: "errorCreatingTrial",
  AlreadySubscribed: "alreadySubscribed",
  HasBundlePlan: "hasBundlePlan",
  PackageNotFound: "packageNotFound",
} as const;

export type Code = (typeof ErrorCode)[keyof typeof ErrorCode];

export function useErrors() {
  function error(code: Code | undefined): string {
    switch (code) {
      case ErrorCode.FeedCreateFail:
        return "Failed to create feed. Please try again or contact support.";
      case ErrorCode.FeedUpdateFail:
        return "Failed to update feed. Please try again or contact support.";
      case ErrorCode.NeedsSubscription:
        return "A subscription is required to perform this action.";
      case ErrorCode.ErrorCreatingTrial:
        return "Could not create trial. Please contact support.";
      case ErrorCode.AlreadySubscribed:
        return "You are already subscribed to this package.";
      case ErrorCode.HasBundlePlan:
        return "You already have an active Everything subscription.";
      case ErrorCode.PackageNotFound:
        return "The selected subscription package was not found.";
      default:
        return "An unexpected error occurred.";
    }
  }

  return { error };
}
